import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { AppSettings } from '@config/app-settings';
import { useAppSelector } from '@store/hooks';
import Loading from '@components/Shared/Loader/Loading';
import BuilderDashboard from './BuilderDashboard';
// import {BuildGrid2} from './BuildGrid2';

interface Props {
  DashboardList: any[];
  loading?: boolean;
}

const Index2: React.FC<Props> = props => {
  const { t, i18n } = useTranslation();
  const Navigate = useNavigate();
  const [dashboard, setDashboard] = useState<any>(null);
  // const [search, setSearch] = useState('');
  const { loading } = useAppSelector(state => state.Reports);

  const context = useContext(AppSettings);

  useEffect(() => {
    context.setAppContentFullHeight(true);
    context.setAppContentClass('p-0');
    context.setAppSidebarCollapsed(true);

    return function cleanUp() {
      context.setAppContentFullHeight(false);
      context.setAppContentClass('');
      context.setAppSidebarCollapsed(false);
    };

    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div className='d-block d-md-flex align-items-stretch h-100 '>
        <div className='gallery-menu-container border-end bg-inverse bg-opacity-5 shadow'>
          <div className='p-3'>
            <div className='d-flex align-items-center  '>
              <Link
                to={''}
                onClick={() => Navigate(-1)}
                className='btn btn-outline-default text-nowrap btn-sm px-3 rounded-pill w-100 mb-2'
              >
                <i
                  className={`fa ${i18n.language === 'ar' ? 'fa-arrow-right me-2 me-n1' : 'fa-arrow-left me-2 ms-n1'}`}
                ></i>
                {t('Back')}
              </Link>
            </div>

            {/* <input
              type='search'
              className='form-control form-control-sm'
              placeholder='بحث...'
              value={search}
              onChange={e => setSearch(e.target.value)}
            /> */}
          </div>
          <hr className='shadow-lg m-0' />
          <PerfectScrollbar options={{ suppressScrollX: true }} className='' style={{ height: 'calc(100% - 107px)' }}>
            <Loading loading={loading} Type='Dots'>
              <div className='gallery-menu'>
                <div className='gallery-menu-header'>{t('لوحة البيانات')}</div>
                {props.DashboardList?.length > 0 ? (
                  props.DashboardList?.map((item, index) => (
                    <div key={index} className='gallery-menu-item'>
                      <Link
                        to=''
                        className={`gallery-menu-link ${item.id === dashboard?.id ? 'active' : ''} `}
                        onClick={() => setDashboard(item)}
                      >
                        <i className={`${item.icon || 'fas fa-file-alt  '} fa-lg me-1`}></i> {item.name}
                      </Link>
                    </div>
                  ))
                ) : (
                  <div className='text-center text-muted py-5'>
                    <i className='fas fa-exclamation-circle fa-2x mb-2'></i>
                    <div>{t('No reports found')}</div>
                  </div>
                )}
              </div>
            </Loading>
          </PerfectScrollbar>
        </div>

        <div className='gallery-content-container'>
          <PerfectScrollbar options={{ suppressScrollX: true }} className='h-100'>
            <div className='gallery-content'>
              <div className='gallery'>
                {dashboard ? (
                  <>
                    <div className='d-flex align-items-center mb-3'>
                      <div className='gallery-title mb-0'>
                        <Link to=''>
                          <i className={`${dashboard?.icon} fa-lg text-theme me-1`}></i>
                          {i18n.language === 'en' ? dashboard?.name : dashboard?.name2}
                          <small>{i18n.language === 'en' ? dashboard?.moduleName : dashboard?.moduleName2}</small>
                        </Link>
                      </div>
                    </div>

                    <div className='gallery-image position-relative  '>
                      {dashboard && <BuilderDashboard dashboardId={dashboard.id} />}
                      {/* <GridStackExample/> */}
                    </div>
                  </>
                ) : (
                  <div className='text-center text-muted py-5'>
                    <i className='fas fa-file-alt fa-3x mb-3'></i>
                    <div>{t('Please select a report to preview')}</div>
                  </div>
                )}
              </div>
            </div>
          </PerfectScrollbar>
        </div>
      </div>
    </>
  );
};

export default Index2;
